import Vue, { watch } from "vue";
import { Component, Watch } from "vue-property-decorator";
import { GeneralButton, FlexContainer, VerticalSpace } from "@/components";
import { SearchButton, Input } from "../../atom";
import { UserListItem } from "../../organism";
import { SearchBar, OrgChartTree, SearchResult } from "../../organism";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as types from "../../../store/types";
import DataLoading from "../DataLoadingView/DataLoading.vue";


@Component({
	components: {
		DataLoading,
		OrgChartTree,
		SearchResult,
		SearchButton,
		SearchBar,
		Input,
		// base - atom
		FlexContainer,
		GeneralButton,
		VerticalSpace,
		// molecule
		UserListItem,
	},
	computed: {
		...mapGetters({
			currentCompany: types.RECIPIENT_CURRENT_COMPANY,
			selectedUsers: types.RECIPIENT_USER_SELECT,
			viewMode: types.RECIPIENT_VIEW_MODE,
		}),
	},
	methods: {
		...mapActions({
			changeSelectAll: types.RECIPIENT_USER_SELECTALL,
			intialize: types.RECIPIENT_INIT,
		}),
		...mapMutations({
			changeViewMode: types.RECIPIENT_VIEW_MODE,
			treeLoadState: types.RECIPIENT_LOADING,
		}),
	},
})
export default class DeptTreeView extends Vue {
	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: G E T T E R S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	selectedUsers!: { [key: string]: recipient.OrgPerson | recipient.Department };
	viewMode!: recipient.ViewMode;
	currentCompany!: string | undefined;

	treeLoading: boolean = true;

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: A C T I O N S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	changeSelectAll!: (select: boolean) => Promise<void>
	intialize!: () => Promise<any>;
	treeLoadState!: (flag: boolean) => Promise<void>

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: M E T H O D S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	@Watch('currentCompany')
	onCompanyChanged(newVal: string) {
		this.treeLoading = true;
		this.intialize().finally(() => {
			this.treeLoading = false;
		})
	}

	get selectedCount(): string {
		return this.$t('N명_선택됨', {
			number: this.selectedUsers.length
		}).toString()
	}

	created() {
		this.treeLoadState(this.treeLoading = true);
		this.intialize().finally(() => {
			this.treeLoading = false;
			this.treeLoadState(this.treeLoading);
		});
	}

	/**
	 * Outlook context 화면을 닫습니다
	 */
	closeContext() {
		if (Office.context.ui.closeContainer) {
			Office.context.ui.closeContainer();
		}
	}

	/**
	 * 모든 선택 상태를 해제합니다.
	 */
	unselectAll() {
		this.changeSelectAll(false);
	}

	/**
	 * 선택된 사용자를 Office.js를 이용하여 OWA 작성 창의 to, cc, bcc에 추가합니다.
	 * @param type 선택된 사용자를 추가할 컨테이너 위치
	 */
	AddRcpts(type: "to" | "cc" | "bcc") {
		const selections = this.selectedUsers;
		const users = Object.keys(selections)
			// 사용자 정의 속성 length를 제외하고
			.filter((key) => key != "length")
			.map((key: string) => {
				const user = selections[key] as any;
				return {
					displayName: user.displayName || user.deptName,
					emailAddress: user.email,
				};
			});


		const item = Office.context.mailbox.item;
		if (item) {
			var toRecipients: Office.Recipients;
			if (item.itemType == Office.MailboxEnums.ItemType.Appointment) {
				// Handle appointment vs message
				toRecipients = item.requiredAttendees;
			} else {
				switch (type) {
					case "to":
						toRecipients = item.to;
						break;

					case "cc":
						toRecipients = item.cc;
						break;

					case "bcc":
						toRecipients = item.bcc;
						break;
				}
			}

			// Perform the async get (compose add-in…read add-in can simply call item.to)
			toRecipients.getAsync((asyncResult) => {
				const newrcpts: {
					displayName: string;
					emailAddress: string;
				}[] = [];
				[...asyncResult.value, ...users].forEach((user) => {
					const email = user.emailAddress;
					// 중복 제거
					if (email && newrcpts.findIndex((x) => x.emailAddress === email) < 0) {
						newrcpts.push({
							displayName: user.displayName,
							emailAddress: email,
						});
					}
				});

				// Perform the async set
				toRecipients.setAsync(newrcpts, function (r) {
					// check status.
				});
			});
		}


		// 수신자 추가 후 선택 초기화
		this.unselectAll();
	}
}
